module.exports = __webpack_public_path__ + "static/silhouette-girl2-1faa508d2bb930616fafc120f52d541c.svg";